export default __webpack_public_path__ + "static/media/hawamahal.5a8a5922.jpg";